<template>
  <v-card id="contractor-company" height="100%" tile>
    <v-card-title>
      <v-toolbar flat>
        <v-toolbar-title>
          <v-row>
            <v-col>
              {{ resx.labels.contractor }}
            </v-col>
            <v-col>
              <v-text-field
                append-icon="search"
                :label="resx.labels.search"
                single-line
                hide-details
                v-on:input="holdSearch"
                v-model="filters.search"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="table-container fixed-header">
      <!--
      <v-card-title>
        {{ resx.labels.contractor }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="resx.labels.search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      -->
      <v-row>
        <v-col shrink class="col-6">
          <v-autocomplete
            menu-props="left, offsetY"
            style="z-index: 100!important"
            clearable
            :items="contractorTypes"
            :label="`${resx.labels.contractorType}`"
            item-text="name"
            item-value="_id"
            v-model="filters.filterContractorType"
            name="company"
            @change="holdContractorType"
          />
        </v-col>
        <v-col
          shrink
          class="col-4"
          v-if="
            $store.state.auth.user.roles[0] ==
              $store.state.constants.roles.SYS_ADMIN
          "
        >
          <v-select
            menu-props="left, offsetY"
            style="z-index: 100!important"
            clearable
            :items="companies"
            :label="`${resx.labels.company}`"
            item-text="name"
            item-value="_id"
            v-model="filters.filterCompany"
            @change="holdCompany"
            :no-data-text="resx.messages.noSelectorDataAvailable"
            :disabled="loading"
          />
        </v-col>
        <v-col class="count-items">
          <v-col>
            <span v-if="items.length > 0">{{
              `${resx.labels.countItems}: ${count}`
            }}</span>
          </v-col>
        </v-col>
        <v-col ref="tableScrollable">
          <v-data-table
            :class="{ 'layout-fixed': $vuetify.breakpoint.lgAndUp }"
            :headers="headers"
            :items="items"
            :search="filters.search"
            :loading="loading"
            :no-data-text="resx.messages.noContractorsAvailable"
            :no-results-text="resx.messages.noContractorsFound"
            fixed-header
            sort-by="contractor.name"
            ref="dataTable"
            loading-text=""
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
          >
          <template v-slot:loading>
            <BarLoader :isLoading=loading />
          </template>
            <template v-slot:item.hasDelayed="{ item }">
              <td class="justify-center align-center px-0 text-sm-center">
                <v-tooltip bottom v-if="item.hasDelayed">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="error">error</v-icon>
                  </template>
                  {{ resx.messages.hasDelayedObligations }}
                </v-tooltip>
                <v-icon v-else color="success">check_circle</v-icon>
              </td>
            </template>
            <template v-slot:item.contractor.name="{ item }">
              <td class="word-wrap">
                <v-row align-center justify-center>
                  <v-col justify-center>
                    <a
                      @click.prevent="
                        $router.push(`/contractors/${item._id}/profile`)
                      "
                    >
                      {{ item.contractor.name }}
                    </a>
                  </v-col>
                </v-row>
              </td>
            </template>
            <template v-slot:item.identifier.number="{ item }">
              <td class="hidden-sm-and-down word-wrap">
                {{ item.contractor.identifier.number }}
              </td>
            </template>
            <template v-slot:item.contractorType="{ item }">
              <td class="hidden-sm-and-down word-wrap">
                {{ item.type.name }}
              </td>
            </template>
            <template v-slot:item.address="{ item }">
              <td class="hidden-sm-and-down word-wrap">
                {{ buildAddress(item) }}
              </td>
            </template>
            <template v-slot:item.zipcode="{ item }">
              <td class="hidden-sm-and-down word-wrap">
                {{ item.contractor.zipcode }}
              </td>
            </template>
            <template v-slot:item.province="{ item }">
              <td class="hidden-sm-and-down word-wrap">
                {{ item.contractor.province }}
              </td>
            </template>
            <template v-slot:item.actions="{ item }">
              <td
                class="justify-center text-sm-center px-0 actionButton"
                v-if="
                  hasRole($store.state.constants.roles.ALL_SYS_ROLES)
                "
              >
                <div class="d-flex align-center justify-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon @click="manageObligations(item)">
                        <v-icon
                          :color="
                            hasObligationsDelayed(
                              item,
                              $store.state.constants.OBLIGATIONS.TYPES
                                .OBLIGATION
                            )
                              ? 'error'
                              : 'primary'
                          "
                          >description</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>{{ resx.labels.obligations }}</span>
                  </v-tooltip>
                <div
                  v-if="hasRole([$store.state.constants.roles.SYS_ADMIN])"
                  v-closable="{
                    handler: 'clickAway',
                    excludeClass: ['actionButton']
                  }"
                >
                  <v-btn
                    class="v-menu__activator"
                    @click="markOpened(item.id)"
                    icon
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>

                  <div
                    class="v-menu-simulation"
                    v-if="!openDialog && isActionSelected(item.id)"
                  >
                    <v-list>
                      <v-list-item @click="edit(item)">
                        <v-list-item-action>
                          <v-icon color="primary">mode_edit</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          resx.labels.edit
                        }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="manageVehicles(item)">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              hasObligationsDelayed(
                                item,
                                $store.state.constants.OBLIGATIONS.TYPES
                                  .VEHICLE_OBLIGATION
                              )
                                ? 'error'
                                : 'primary'
                            "
                            >commute</v-icon
                          >
                        </v-list-item-action>
                        <v-list-item-title
                          :class="{
                            'error--text': hasObligationsDelayed(
                              item,
                              $store.state.constants.OBLIGATIONS.TYPES
                                .VEHICLE_OBLIGATION
                            )
                          }"
                          >{{ resx.labels.vehicles }}</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item @click="manageEmployees(item)">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              hasObligationsDelayed(
                                item,
                                $store.state.constants.OBLIGATIONS.TYPES
                                  .EMPLOYEES_OBLIGATION
                              )
                                ? 'error'
                                : 'primary'
                            "
                            >people</v-icon
                          >
                        </v-list-item-action>
                        <v-list-item-title
                          :class="{
                            'error--text': hasObligationsDelayed(
                              item,
                              $store.state.constants.OBLIGATIONS.TYPES
                                .EMPLOYEES_OBLIGATION
                            )
                          }"
                          >{{ resx.labels.employees }}</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item @click="reportSettingsFor = item">
                        <v-list-item-action>
                          <v-icon>assignment</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Reporte mensual</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="remove(item)">
                        <v-list-item-action>
                          <v-icon color="error">delete</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          resx.labels.delete
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </div>
                </div>
                </div>
              </td>
            </template>
            <!--
              <template v-slot:item="{ item, expand, isExpanded }">
                <tr :class="{ 'disable-row': item.isActive == false }">
                </tr>
              </template>
              -->
            <template v-slot:expanded-item="{ headers, item }">
              <tr>
                <v-list
                  two-line
                  v-if="
                    item.contractor.contactName ||
                      item.contractor.contactPhone ||
                      item.contractor.contactEmail ||
                      item.contactName ||
                      item.contactPhone ||
                      item.contactEmail
                  "
                >
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="primary">people</v-icon>
                    </v-list-item-action>
                    <v-list-item-content
                      v-if="
                        item.contactName ||
                          item.contactPhone ||
                          item.contactEmail
                      "
                    >
                      <v-list-item-title v-if="item.contactName">{{
                        item.contactName
                      }}</v-list-item-title>
                      <v-list-item-title v-if="item.contactPhone"
                        ><a :href="`tel:${item.contactPhone}`">{{
                          item.contactPhone
                        }}</a></v-list-item-title
                      >
                      <v-list-item-title v-if="item.contactEmail"
                        ><a :href="`mailito:${item.contactEmail}`">{{
                          item.contactEmail
                        }}</a></v-list-item-title
                      >
                    </v-list-item-content>
                    <v-list-item-content
                      v-else-if="
                        item.contractor.contactName ||
                          item.contractor.contactPhone ||
                          item.contractor.contactEmail
                      "
                    >
                      <v-list-item-title v-if="item.contractor.contactName">{{
                        item.contractor.contactName
                      }}</v-list-item-title>
                      <v-list-item-title v-if="item.contractor.contactPhone"
                        ><a :href="`tel:${item.contractor.contactPhone}`">{{
                          item.contractor.contactPhone
                        }}</a></v-list-item-title
                      >
                      <v-list-item-title v-if="item.contractor.contactEmail"
                        ><a :href="`mailito:${item.contractor.contactEmail}`">{{
                          item.contractor.contactEmail
                        }}</a></v-list-item-title
                      >
                    </v-list-item-content>
                    <v-list-item-content v-else></v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list
                  two-line
                  v-if="
                    item.contractor.contactName1 ||
                      item.contractor.contactPhone1 ||
                      item.contractor.contactEmail1 ||
                      item.contactName1 ||
                      item.contactPhone1 ||
                      item.contactEmail1
                  "
                >
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="primary">people</v-icon>
                    </v-list-item-action>
                    <v-list-item-content
                      v-if="
                        item.contactName1 ||
                          item.contactPhone1 ||
                          item.contactEmail1
                      "
                    >
                      <v-list-item-title v-if="item.contactName1">
                        {{ item.contactName1 }}
                      </v-list-item-title>
                      <v-list-item-title v-if="item.contactPhone1"
                        ><a :href="`tel:${item.contactPhone1}`">{{
                          item.contactPhone1
                        }}</a></v-list-item-title
                      >
                      <v-list-item-title v-if="item.contactEmail1"
                        ><a :href="`mailito:${item.contactEmail1}`">{{
                          item.contactEmail1
                        }}</a></v-list-item-title
                      >
                    </v-list-item-content>
                    <v-list-item-content
                      v-else-if="
                        item.contractor.contactName1 ||
                          item.contractor.contactPhone1 ||
                          item.contractor.contactEmail1
                      "
                    >
                      <v-list-item-title v-if="item.contractor.contactName1">{{
                        item.contractor.contactName1
                      }}</v-list-item-title>
                      <v-list-item-title v-if="item.contractor.contactPhone1"
                        ><a :href="`tel:${item.contractor.contactPhone1}`">{{
                          item.contractor.contactPhone1
                        }}</a></v-list-item-title
                      >
                      <v-list-item-title v-if="item.contractor.contactEmail1"
                        ><a
                          :href="`mailito:${item.contractor.contactEmail1}`"
                          >{{ item.contractor.contactEmail1 }}</a
                        ></v-list-item-title
                      >
                    </v-list-item-content>
                    <v-list-item-content v-else></v-list-item-content>
                  </v-list-item>
                </v-list>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <div>
          <v-btn
            color="accent"
            class="addButton"
            fab
            bottom
            right
            absolute
            v-if="
              $store.state.auth.user.roles[0] ==
                $store.state.constants.roles.SYS_ADMIN
            "
            @click="create"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </v-row>
      <v-row>
        <edit-contractor-company
          v-model="openDialog"
          :contractor-companies="items"
          v-on:close="onClose"
          v-on:save="onSave"
        ></edit-contractor-company>
      </v-row>
      <report-settings-dialog
        v-if="reportSettingsFor"
        :contractor-company="reportSettingsFor"
        @close="reportSettingsFor = null"
      />
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";
import { sprintf } from "sprintf-js";
import _ from "lodash";
import moment from "moment";
import companyService from "@/services/CompanyService";
import contractorCompanyService from "@/services/ContractorCompanyService";
import roles from "@/utils/roles";
import store from "@/store/store";
import editContractorCompany from "@/components/views/contractor-company/edit-contractor-company.view.vue";
// import commentsComponent from "../../commons/comments.vue";
import reportSettingsDialog from "@/components/views/contractor-company/report-settings-dialog.component.vue";
import BarLoader from "@/components/common/bar-loader.vue";
import Vue from "vue";
// document's click handler
let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = e => {
      e.stopPropagation();
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, excludeClass } = binding.value;
      let clickedOnExcludedEl = false;
      excludeClass.forEach(refName => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          var elements = document.getElementsByClassName(refName);
          Array.prototype.forEach.call(elements, function(excludedEl) {
            // See if this excluded element
            // is the same element the user just clicked on
            if (!clickedOnExcludedEl && excludedEl) {
              clickedOnExcludedEl = excludedEl.contains(e.target);
            }
          });
        }
      });
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]();
      }
    };
    // Register click/touchstart event listeners on the whole page
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  },
  unbind() {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener("click", handleOutsideClick);
    document.removeEventListener("touchstart", handleOutsideClick);
  }
});
export default {
  mixins: [],
  components: {
    editContractorCompany,
    reportSettingsDialog,
    BarLoader
    // commentsComponent
  },
  props: {
    filter: { type: String, default: "all" }
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      search: "",
      loading: true,
      companies: [],
      contractorTypes: [],
      headers: [
        {
          align: "center",
          text: "",
          value: "hasDelayed"
        },
        {
          text: resx.labels.nameOrBusinessName,
          value: "contractor.name",
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.identifierText,
          value: "contractor.identifier.number",
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.contractorType,
          value: "type.name",
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.address,
          value: "contractor.address"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.zipcode,
          value: "contractor.zipcode"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.province,
          value: "contractor.province"
        },
            // Below are for filter only
        {
          class: "hidden",
          text: resx.labels.company,
          value: "company._id",
          filter: this.companyFilter
        },
        {
          class: "hidden",
          text: resx.labels.contractorType,
          value: "type._id",
          filter: this.contractorTypeFilter
        },
        {
          class: "hidden",
          align: "d-none",
          value: "contractor.strippedIdentifierNumber",
        },
        {
          class: "hidden",
          align: "d-none",
          value: "strippedName"
        },
      ],
      items: [],
      openDialog: null,
      reportSettingsFor: null,
      filters: {
        filterCompany: null,
        filterContractorType: null,
        search: null
      }
    };
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    async loadData() {
      this.loading = true;
      try {
        this.items = await contractorCompanyService.list(this.filter !== "all" ? this.filter : undefined);
        this.companies = await companyService.getCompanies(true);
        Object.keys(this.items).forEach(index => {
          this.items[index].strippedIdentifier = this.items[index].contractor.identifier.number.replaceAll(" ", "").replaceAll("-", "");
          this.items[index].strippedName = this.items[index].contractor.name.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "").replaceAll(" ", "").replaceAll("-", "");
        });
        if (roles.loggedUserHasRoles(this.$store.state.auth.user.roles, [
          this.$store.state.constants.roles.ADMIN,
          this.$store.state.constants.roles.SECURITY
        ])) {
          this.filters.filterCompany = this.$store.state.auth.user.company._id;
        }
        if (
          roles.loggedUserHasRoles(
            this.$store.state.auth.user.roles,
            this.$store.state.constants.roles.ALL_SYS_ROLES
          ) && !this.headers.find(h => h.value === "actions")
        ) {
          this.headers.push({
            class: "hidden-sm-and-down",
            text: this.$store.state.locale.resx.labels.actions,
            align: "center",
            value: "actions"
          });
        }
        this.populateTypes(this.items);
      } catch (error) {
        console.error("Error loading data: ", error);
      } finally {
        this.loading = false;
      }
    },
    create() {
      this.openDialog = {};
    },
    async edit(contractorCompany) {
      contractorCompany = await contractorCompanyService.getById(contractorCompany._id);
      this.openDialog = {
        selectedItem: contractorCompany
      };
    },
    async remove(contractorCompany) {
      await this.botConfirmDialog({
        title: `${
          this.resx.labels.delete
        } ${this.resx.labels.contractor.toLowerCase()}`,
        content: sprintf(
          this.resx.messages.deleteContractorMessage,
          contractorCompany.contractor.name
        )
      });
      let deleted = await contractorCompanyService.remove(
        contractorCompany._id
      );
      const index = this.items.findIndex(
        o => o._id == contractorCompany._id && deleted.isDeleted
      );
      this.items.splice(index, 1);
    },
    onClose() {
      this.openDialog = null;
      let query = Object.assign({}, this.$route.query);
      query.contractor_id = query.hold_contractor_id;
      delete query.hold_contractor_id;
      this.$router.replace({ query });
    },
    onSave(action) {
      if (action.isNew) {
        this.items.push(action.item);
      } else {
        this.$set(
          this.items,
          this.items.findIndex(i => i._id == action.item._id),
          action.item
        );
        this.populateTypes();
      }
      this.onClose();
    },
    buildAddress(item) {
      return `${item.contractor.address} ${item.contractor.addressNumber} ${
        item.contractor.floor ? item.contractor.floor : ""
      } ${item.contractor.office ? item.contractor.office : ""}`;
    },
    parseDate(d) {
      return moment.utc(d).format(store.state.constants.DATE_FORMAT);
    },
    manageObligations(contractorCompany) {
      this.$router.push(`/contractors/${contractorCompany._id}/obligations`);
    },
    manageVehicles(contractorCompany) {
      this.$router.push(`/contractors/${contractorCompany._id}/vehicles`);
    },
    manageEmployees(contractorCompany) {
      this.$router.push(`/contractors/${contractorCompany._id}/employees`);
    },
    hasObligationsDelayed(contractorCompany, type) {
      return (
        contractorCompany.delayedObligations.filter(o => o.type == type)
        .length > 0
      );
    },
    populateTypes(items) {
      this.contractorTypes = _.uniqWith(items, (a, b) => {
        return a.type._id == b.type._id;
      }).map(i => i.type);
    },
    nameFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.filters.search) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "").toLowerCase().includes(this.filters.search.toLowerCase());
    },
    identifierFilter(number) {
      number = number.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "");
      const re = new RegExp(number, "i");
      this.search = this.contractor.identifier.number.filter(c => {
        return re.test( number.indexOf("-") == -1 ? c.contractor.identifier.number.replaceAll("-", "")
        : c.contractor.identifier.number);
      });
    },
    companyFilter(companyId) {
      if (!this.filters.filterCompany) {
        return true;
      }
      return companyId == this.filters.filterCompany;
    },
    contractorTypeFilter(contractorTypeId) {
      if (!this.filters.filterContractorType) {
        return true;
      }
      return contractorTypeId == this.filters.filterContractorType;
    },
    hasRole(allowedRoles) {
      return roles.loggedUserHasRoles(
        this.$store.state.auth.user.roles,
        allowedRoles
      );
    },
    markOpened(contractor_company_id) {
      let query = Object.assign({}, this.$route.query);
        if (this.$route.query.contractor_company_id == contractor_company_id) {
        delete query.contractor_company_id;
      } else {
        query.contractor_company_id = contractor_company_id;
      }
      this.$router.replace({ query });
    },
    isActionSelected(contractor_company_id) {
      return contractor_company_id == this.$route.query.contractor_company_id   ;
    },
    clickAway() {
      if (this.$route.query.contractor_id) {
        let query = Object.assign({}, this.$route.query);
        query.hold_contractor_id = query.contractor_id;
        delete query.contractor_id;
        this.$router.replace({ query });
      }
    },
    holdContractorType(contractor_type_id) {
      let query = Object.assign({}, this.$route.query);
      if (contractor_type_id) {
        query.contractor_type_id = contractor_type_id;
      } else {
        delete query.contractor_type_id;
      }
      this.$router.replace({ query });
    },
    holdCompany(company_id) {
      let query = Object.assign({}, this.$route.query);
      if (company_id) {
        query.company_id = company_id;
      } else {
        delete query.company_id;
      }
      this.$router.replace({ query });
    },
    holdSearch(search_string) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: search_string
      });
      let query = Object.assign({}, this.$route.query);
      if (search_string) {
        query.search = search_string;
      } else {
        delete query.search;
      }
      this.$router.replace({ query });
    }
  },
  computed: {
    count: function() {
      let currentItems = this.$refs.dataTable.internalCurrentItems;
      let count = Object.keys(currentItems).length;
      return count;
    }
  },
  async mounted() {
    await this.loadData();
    let self = this;
    if (this.$route.query.contractor_id) {
      setTimeout(function() {
        self.$refs.tableScrollable.scrollLeft = 400;
      }, 200);
    }
    if (this.$route.query.contractor_type_id) {
      this.filters.filterContractorType = this.$route.query.contractor_type_id;
    }
    if (this.$route.query.company_id) {
      this.filters.filterCompany = this.$route.query.company_id;
    }
    if (this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
  }
};
</script>

<style lang="scss">
.v-badge {
  display: flex;
}
#contractor-company {
  .comments-column {
    max-width: 270px;
    .layout.row.wrap {
      padding: 50px !important;
    }
  }
  .contractor-item-menu {
    max-height: initial !important;
  }
  .datatable-cell-wrapper {
    width: inherit;
    position: relative;
    z-index: 4;
    padding: 10px 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .datatable__expand-content .card__text {
    z-index: 3;
    position: relative;
  }
  .v-datatable__expand-col {
    border-bottom: 1px solid #ddd;
  }
  tr.disable-row {
    opacity: 0.3;
  }
  table.table thead th,
  table.table tbody td {
    padding: 0 16px !important;
  }
  .count-items {
    margin-top: 8px;
    min-width: 100px;
    text-align: right;
    z-index: 5;
  }
  .v-menu-simulation {
    min-width: 36px;
    transform-origin: left top 0px;
    z-index: 99999;
    position: absolute;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
      0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
    right: 100px;
  }
  .v-toolbar__title {
    width: 100%;
  }
  .v-toolbar__content {
    padding: 14px;
  }
  overflow-y: auto;
//   .v-data-table table tbody tr td:nth-child(4),
  .v-data-table table tbody tr td:nth-child(8),
  .v-data-table table tbody tr td:nth-child(9),
  .v-data-table table tbody tr td:nth-child(10),
  .v-data-table table tbody tr td:nth-child(11) {
    display: none;
  }
  .hidden {
    display: none;
  }
  .v-toolbar__title {
    width: 100%;
  }
  .v-card__text {
    padding-bottom: 70px;
  }
}
</style>